import { Global } from '@emotion/react';
import { Box } from '@mui/material';
import React from 'react';
import { Outlet, useLocation } from 'react-router';

import Snackbar from './FeedbackDashboard/FeedbackTab/Feedbacks/Snackbar';
import { feedbackCenterStyles } from './styles';

const useStyles = ({ assign }) => ({
	content: {
		backgroundColor: 'background.default',
		boxSizing: 'border-box',
		width: '100%',
		height: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		opacity: assign ? 0 : 1,
	},
});

export function FeedbackCenterLayout() {
	const { pathname } = useLocation();

	const classes = useStyles({ assign: pathname === '/request' });

	return (
		<>
			<Global styles={feedbackCenterStyles} />
			<Box sx={classes.content} data-testid="layout">
				<Outlet />
				<Snackbar />
			</Box>
		</>
	);
}
